import '@babel/polyfill'
import Vue from 'vue'

import '@/plugins/vuesax'

import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import VueHead from 'vue-head'

import '@/firebase'
import '@/firebase/authPersistence'

import ClickawayDirective from '@/directives/clickaway'
import VueMasonry from 'vue-masonry-css'
import VueBreadcrumbs from 'vue-breadcrumbs'
import axios from 'axios'
import VueAxios from 'vue-axios'

import VueMultianalytics from 'vue-multianalytics'

import config from '@/config/config'
import Popover from 'vue-js-popover'
import VueToast from 'vue-toast-notification'
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate/dist/vee-validate.full'
import 'web-animations-js'

import 'vue-toast-notification/dist/index.css'
import '@/assets/styles/main.scss'
import VueLogger from 'vuejs-logger'
import VueObserveVisibility from 'vue-observe-visibility'
import VueYouTubeEmbed from 'vue-youtube-embed'

import VCalendar from 'v-calendar'
Vue.use(VCalendar)

Vue.use(VueYouTubeEmbed, { global: true, componentId: 'tapkit-youtube-media' })

Vue.use(VueObserveVisibility)

const isProduction = process.env.NODE_ENV === 'production'

const options = {
  isEnabled: true,
  logLevel: isProduction ? 'error' : 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true
}
Vue.use(VueLogger, options)

ClickawayDirective.register(Vue)

Vue.use(VueMasonry)
Vue.use(Popover)
Vue.use(VueAxios, axios)
Vue.use(VueHead)

extend('one_special_char', {
  message: 'The password must contain at least: one uppercase letter, one lowercase letter, one number, and one special character',
  validate: value => {
    const strongRegex = new RegExp('^(?=.*[!@#$%^&*])')
    return strongRegex.test(value)
  }
})

extend('one_upper_case', {
  message: 'The password must contain at least: one uppercase letter, one lowercase letter, one number, and one special character',
  validate: value => {
    const strongRegex = new RegExp('^(?=.*[A-Z])')
    return strongRegex.test(value)
  }
})

extend('one_lower_case', {
  message: 'The password must contain at least: one uppercase letter, one lowercase letter, one number, and one special character',
  validate: value => {
    const strongRegex = new RegExp('^(?=.*[a-z])')
    return strongRegex.test(value)
  }
})

extend('one_number', {
  message: 'The password must contain at least: one uppercase letter, one lowercase letter, one number, and one special character',
  validate: value => {
    const strongRegex = new RegExp('^(?=.*[0-9])')
    return strongRegex.test(value)
  }
})

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

Vue.use(VueBreadcrumbs, {
  registerComponent: false
})
Vue.use(VueToast)
Vue.config.productionTip = false

const maModules = {}
if (config.ENV !== 'development') {
  var googleAnalyticsConfig = {
    appVersion: '0.1',
    debug: (config.ENV === 'development' || config.ENV === 'alpha'),
    trackingId: config.GA_ID_APP,
    appName: 'Faraday App'
  }
  maModules.mixpanel = {
    token: config.MIXPANEL_KEY,
    debug: true
  }
  maModules.ga = googleAnalyticsConfig
}

Vue.use(VueMultianalytics, {
  modules: maModules
})

Vue.config.performance = !isProduction

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
